import React from 'react';
import '../styles/TypingIndicator.css';

function TypingIndicator() {
  return (
    <div className="typing-indicator">
      <div className="typing-dot"></div>
      <div className="typing-dot"></div>
      <div className="typing-dot"></div>
    </div>
  );
}

export default TypingIndicator;
